import React from "react";
import RemoveLiquidity from "./RemoveLiquidity";
import DepositWithdraw from "./DepositWithdraw";
import Claim from "./Claim";
import Lend from "./Lend";
import Borrow from "./Borrow";
import WalletConfirm from "./WalletConfirm";
import BackWrapper from "./parts/BackWrapper";
import SwapSupply from "./SwapSupply";
import * as Modals from "../redux/modalsTypes";
import { useSelector } from "react-redux";
import FarmPage from "./FarmPage";
import FarmCohort from "./FarmCohort";
import Confirm from "./Confirm";
import Approve from "./Approve";
import Buy from "./Buy";
import ApproveDeposite from "./ApproveDeposite";
import Max from "./Max";
import CONNECT_WALLET from "./ConnectWallet";

export default function () {
  const modalType = useSelector((state) => state.modal.window);
  return (
    <>
      {modalType !== null && (
        <BackWrapper>
          {modalType === Modals.LB_LEND && <Lend />}
          {modalType === Modals.LB_BORROW && <Borrow />}
          {modalType === Modals.WALLET_CONFIRM && <WalletConfirm />}
          {modalType === Modals.CONFIRM && <Confirm />}
          {modalType === Modals.FARM_PAGE && <FarmPage />}
          {modalType === Modals.FARM_PAGE_COHORT && <FarmCohort />}
          {modalType === Modals.FARM_CLAIM && <Claim />}
          {modalType === Modals.FARM_DW && <DepositWithdraw />}
          {modalType === Modals.REMOVE_LIQUIDITY && <RemoveLiquidity />}
          {modalType === Modals.SWAP_SUPPLY && <SwapSupply />}
          {modalType === Modals.APPROVE_DEPOSIT && <ApproveDeposite />}
          {modalType === Modals.BUY && <Buy />}
          {/*  {modalType === Modals.MAX && <Max />} */}
          {modalType === Modals.CONNECT_WALLET && <CONNECT_WALLET />}
        </BackWrapper>
      )}
    </>
  );
}
